import { TextField, textFieldTemplate as template } from '@microsoft/fast-foundation';
import { InputFieldComponent } from './InputField';
import { inputFieldDefinition } from './InputFieldBase';
export const fieldDefinition = {
    ...inputFieldDefinition('input-field', template),
    baseClass: TextField,
};
export const chameleonInputField = InputFieldComponent.compose(fieldDefinition);
